import { ContenedorPageTemplate } from "../../../components/templates/ContenedorPageTemplate";
import { Link, useLocation, useParams } from "react-router-dom";

export const RegistroEstudianteDetalle = () => {
  const location = useLocation();
  const { registro } = location.state || {};

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(
      () => alert("Copiado al portapapeles"),
      (err) => alert("Error al copiar")
    );
  };

  const formatearNota = (nota) => {
    if (nota === null || nota === undefined || nota === "") return "-";
    return parseFloat(nota).toFixed(1);
  };

  const obtenerEstadoColor = (estado) => {
    switch (estado) {
      case 'Aprobado':
        return 'bg-green-100 text-green-800 border-green-300';
      case 'Reprobado':
        return 'bg-red-100 text-red-800 border-red-300';
      case 'Culminado':
        return 'bg-blue-100 text-blue-800 border-blue-300';
      default:
        return 'bg-yellow-100 text-yellow-800 border-yellow-300';
    }
  };

  if (!registro) {
    return (
      <ContenedorPageTemplate fondo={false}>
        <div className="text-center py-8">
          <p className="text-gray-600">No se encontró información del registro.</p>
        </div>
      </ContenedorPageTemplate>
    );
  }

  return (
    <ContenedorPageTemplate fondo={false}>
      <section className="mx-auto px-4 py-8 max-w-7xl">
        {/* Encabezado del Grupo */}
        <div className="bg-gradient-to-r from-theme-blue to-blue-800 rounded-t-xl shadow-lg mb-6">
          <div className="p-6 text-white">
            <h2 className="text-3xl font-bold mb-2">{registro?.grupo?.nombre || "Grupo sin nombre"}</h2>
            <div className="flex flex-wrap gap-4 text-sm opacity-90">
              <span className="flex items-center gap-1">
                <span className="font-semibold">Módulo:</span> {registro?.grupo?.modulo?.nombre} ({registro?.grupo?.modulo?.sigla})
              </span>
              <span className="flex items-center gap-1">
                <span className="font-semibold">Idioma:</span> {registro?.grupo?.idioma?.nombre || registro?.grupo?.modulo?.idioma?.nombre || registro?.idioma?.nombre || "N/A"}
              </span>
              <span className="flex items-center gap-1">
                <span className="font-semibold">Turno:</span> {registro?.grupo?.turno?.nombre}
              </span>
              <span className="flex items-center gap-1">
                <span className="font-semibold">Modalidad:</span> {registro?.grupo?.modalidad?.nombre}
              </span>
            </div>
            <div className="mt-4 flex items-center gap-4">
              <span className={`px-4 py-2 rounded-full text-sm font-semibold border-2 ${obtenerEstadoColor(registro?.estadoV2 || registro?.estado)}`}>
                {registro?.estadoV2 || registro?.estado || "Sin estado"}
              </span>
              {registro?.notaFinal !== null && registro?.notaFinal !== undefined && (
                <div className="bg-white/20 backdrop-blur-sm rounded-lg px-4 py-2">
                  <span className="text-sm opacity-90">Nota Final:</span>
                  <span className="text-2xl font-bold ml-2">{formatearNota(registro.notaFinal)}</span>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Contenedor principal */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Columna izquierda - Información del curso */}
          <div className="lg:col-span-1 space-y-6">
            {/* Información del grupo */}
            <div className="bg-white rounded-lg shadow-md p-6 border border-gray-200">
              <h3 className="text-xl font-semibold text-theme-blue mb-4 border-b pb-2">Información del Curso</h3>
              <div className="space-y-3 text-sm">
                <div>
                  <p className="font-semibold text-gray-700">Módulo:</p>
                  <p className="text-gray-600">{`${registro?.grupo?.modulo?.nombre} / ${registro?.grupo?.modulo?.sigla}`}</p>
                </div>
                <div>
                  <p className="font-semibold text-gray-700">Turno:</p>
                  <p className="text-gray-600">{registro?.grupo?.turno?.nombre}</p>
                </div>
                <div>
                  <p className="font-semibold text-gray-700">Modalidad:</p>
                  <p className="text-gray-600">{registro?.grupo?.modalidad?.nombre}</p>
                </div>
                {registro?.grupo?.cuentaZoom && (
                  <div>
                    <p className="font-semibold text-gray-700 mb-1">Link de Zoom:</p>
                    <div className="flex items-center gap-2">
                      <a
                        href={registro?.grupo?.cuentaZoom}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-theme-blue underline hover:text-blue-700 truncate"
                      >
                        {registro?.grupo?.cuentaZoom}
                      </a>
                      <button
                        onClick={() => copyToClipboard(registro?.grupo?.cuentaZoom)}
                        className="bg-theme-yellow hover:bg-yellow-500 text-white px-3 py-1 rounded text-xs font-semibold transition-colors"
                        title="Copiar link"
                      >
                        Copiar
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Horarios */}
            <div className="bg-white rounded-lg shadow-md p-6 border border-gray-200">
              <h3 className="text-xl font-semibold text-theme-blue mb-4 border-b pb-2">Horarios</h3>
              {registro?.grupo?.horarios?.length > 0 ? (
                <ul className="space-y-2">
                  {registro?.grupo?.horarios?.map((horario, index) => (
                    <li key={index} className="flex items-center justify-between p-2 bg-gray-50 rounded border border-gray-200">
                      <span className="text-gray-700 font-medium">{horario?.dia?.nombre}</span>
                      <span className="text-theme-blue font-semibold">
                        {horario?.horaInicio} - {horario?.horaFin}
                      </span>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-center text-gray-500 py-4">No tiene horarios asignados.</p>
              )}
            </div>
          </div>

          {/* Columna derecha - Notas detalladas */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-lg shadow-md p-6 border border-gray-200">
              <h3 className="text-2xl font-bold text-theme-blue mb-6 border-b-2 border-theme-blue pb-3">
                Desglose de Notas
              </h3>

              {/* Tabla de Notas */}
              <div className="overflow-x-auto">
                <table className="w-full border-collapse text-sm">
                  <thead>
                    <tr className="bg-theme-blue text-white">
                      <th className="border border-gray-300 px-4 py-3 text-center font-semibold">Participación<br/><span className="text-xs font-normal opacity-80">(15%)</span></th>
                      <th className="border border-gray-300 px-4 py-3 text-center font-semibold">Tareas<br/><span className="text-xs font-normal opacity-80">(20%)</span></th>
                      <th className="border border-gray-300 px-4 py-3 text-center font-semibold">Proyecto Integrador<br/><span className="text-xs font-normal opacity-80">(20%)</span></th>
                      <th className="border border-gray-300 px-4 py-3 text-center font-semibold">Examen Escrito<br/><span className="text-xs font-normal opacity-80">(20%)</span></th>
                      <th className="border border-gray-300 px-4 py-3 text-center font-semibold">Examen Oral<br/><span className="text-xs font-normal opacity-80">(20%)</span></th>
                      <th className="border border-gray-300 px-4 py-3 text-center font-semibold">Asistencia<br/><span className="text-xs font-normal opacity-80">(5%)</span></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="hover:bg-gray-50 transition-colors">
                      <td className="border border-gray-300 px-3 py-4 text-center text-lg font-bold text-gray-700">{formatearNota(registro.participacion)}</td>
                      <td className="border border-gray-300 px-3 py-4 text-center text-lg font-bold text-gray-700">{formatearNota(registro.tareas)}</td>
                      <td className="border border-gray-300 px-3 py-4 text-center text-lg font-bold text-gray-700">{formatearNota(registro.proyectoIntegrador)}</td>
                      <td className="border border-gray-300 px-3 py-4 text-center text-lg font-bold text-gray-700">{formatearNota(registro.examenFinalEscrito)}</td>
                      <td className="border border-gray-300 px-3 py-4 text-center text-lg font-bold text-gray-700">{formatearNota(registro.examenFinalOral)}</td>
                      <td className="border border-gray-300 px-3 py-4 text-center text-lg font-bold text-gray-700">{formatearNota(registro.asistenciaNota)}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Resumen final */}
              <div className="mt-6 p-4 bg-gradient-to-r from-theme-blue/10 to-blue-50 rounded-lg border-2 border-theme-blue">
                <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
                  <div>
                    <p className="text-sm text-gray-600">Estado del curso:</p>
                    <p className="text-lg font-semibold text-theme-blue">{registro?.estadoV2 || registro?.estado || "Sin estado"}</p>
                  </div>
                  {registro?.nivelModulo && (
                    <div>
                      <p className="text-sm text-gray-600">Nivel:</p>
                      <p className="text-lg font-semibold text-theme-blue">{registro.nivelModulo}</p>
                    </div>
                  )}
                  {registro?.notaFinal !== null && registro?.notaFinal !== undefined && (
                    <div className="text-center sm:text-right">
                      <p className="text-sm text-gray-600">Nota Final:</p>
                      <p className="text-3xl font-bold text-theme-blue">{formatearNota(registro.notaFinal)}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </ContenedorPageTemplate>
  );
};
